import { compose, withState } from 'recompose';
import { connect } from 'react-redux';

import DashboardView from './Dashboard';

export default compose(
  connect((state) => ({
    isSidebarOpened: state.layout.isSidebarOpened,
  })),
  withState('mainChartState', 'setMainChartState', 'monthly'),
)(DashboardView);
